import React from 'react';

const superCropThree = (props) => (
    <svg width="80px" height="65px" viewBox="0 0 82 50" {...props}>
        <defs>
            <circle id="supercrop3-path-1" cx="40" cy="40" r="40" />
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(0.000000, -15.000000)">
                <mask id="supercrop3-mask-2" fill="white">
                    <use xlinkHref="#supercrop3-path-1" />
                </mask>
                <path
                    d="M-24,55.003681 C-7.69017764,28.9829827 6.7808255,15.9726335 19.4130094,15.9726335 C38.3612853,15.9726335 43.4537618,36.5099206 38.4749216,57.6844365 C38.4749216,57.6844365 64.1653605,7.45479961 104,15.9726335 C104,15.9726335 104,37.315089 104,80 L92.2374608,80 C100.851358,60.557721 102.294148,47.4764814 96.5658307,40.7562814 C87.9733542,30.6759813 64.3652038,43.7336779 46.0384013,80 C46.0384013,80 35.042581,80 13.0509404,80 C20.2520899,58.2201691 22.3727795,45.1389296 19.4130094,40.7562814 C14.9733542,34.1823091 2.08777429,47.6567157 -15.9208464,80 C-15.9208464,80 -18.6138976,80 -24,80 L-24,55.003681 Z"
                    fill="#000000"
                    mask="url(#supercrop3-mask-2)"
                />
            </g>
        </g>
    </svg>
);

export default superCropThree;
